export default __webpack_public_path__ + "static/char-v-07-3b6a306a8ff02851e66012cac71bbe0a.webp";